/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Existing_QuoteInputs */

const en_orders_existing_quote = /** @type {(inputs: Orders_Existing_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing quote:`)
};

const es_orders_existing_quote = /** @type {(inputs: Orders_Existing_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotizacion existente:`)
};

/**
* | output |
* | --- |
* | "Existing quote:" |
*
* @param {Orders_Existing_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_existing_quote = /** @type {((inputs?: Orders_Existing_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Existing_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_existing_quote(inputs)
	return es_orders_existing_quote(inputs)
});